import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import camelCase from 'lodash/camelCase';
import { Subjects } from 'views/QuestionsWithCategories/QuestionsWithCategories.data';
import useWindowWidth from 'utils/useWindowWidth';
import { CountByCategoriesResponse } from 'views/Main/types/getCountByCategories';
import styles from './SubjectsList.module.css';

export type SubjectsListProps = {
  countByCategories: CountByCategoriesResponse | null;
};

const SubjectsList = ({ countByCategories }: SubjectsListProps) => {
  const [showMore, setShowMore] = useState(false);
  const windowWidth = useWindowWidth();
  const startIndexDeafaltSubject = windowWidth > 1023 ? 6 : 5;

  const [subjectsListHeight, setSubjectsListHeight] = useState(0);
  const rowSubjectsHeight = 295;

  const containerWidth = useRef<HTMLDivElement | null>(null);
  const maxListHeight = () => {
    const listWidth = containerWidth?.current?.offsetWidth;
    // Вычисление максимальной высоты контейнера от кол-ва элементов
    if (listWidth)
      setSubjectsListHeight(
        Math.ceil(
          ((Subjects.length - startIndexDeafaltSubject) /
            Math.floor(listWidth / (windowWidth < 640 ? 90 : 96))) *
            (windowWidth < 640 ? 110 : 160) +
            300,
        ),
      );
  };

  useEffect(() => {
    maxListHeight();
  }, [windowWidth]);

  const showMoreSubjectsHandler = () => {
    setShowMore(!showMore);
  };

  return (
    <div ref={containerWidth} className={styles.subjects}>
      <div
        style={{ maxHeight: !showMore ? rowSubjectsHeight : subjectsListHeight }}
        className={`${styles.subject__list} ${showMore && styles.show_all_subjects}`}
      >
        <div className={styles.subject_grid}>
          {Subjects.map(
            (i, index) =>
              startIndexDeafaltSubject > index && (
                <Link href={`/categories/${i.link}`} key={i.imageName}>
                  <a className={`${styles.subject_grid__item}`}>
                    <div className={styles.subject_grid__item_img}>
                      <Image
                        src={`https://static.uchi.ru/files/otvety/subjects/${i.imageName}.svg`}
                        alt={i.name}
                        width={60}
                        height={60}
                        priority
                      />
                    </div>
                    <div className={styles.subject_grid__item_text}>
                      <span className={styles.subject_grid__item_title}>{i.name}</span>
                      {countByCategories && (
                        <span className={styles.subject_grid__item_subtitle}>
                          {countByCategories && i.link === ''
                            ? countByCategories.total
                            : countByCategories[camelCase(i.link)]}{' '}
                          вопросов
                        </span>
                      )}
                    </div>
                  </a>
                </Link>
              ),
          )}
        </div>
        <div className={styles.default_subjects}>
          {Subjects.map(
            (i, index) =>
              startIndexDeafaltSubject <= index && (
                <Link href={`/categories/${i.link}`} key={i.imageName} scroll={false}>
                  <a>
                    <div className={styles.subject__item}>
                      <div className={styles.subject__img}>
                        <Image
                          src={`https://static.uchi.ru/files/otvety/subjects/${i.imageName}.svg`}
                          alt={i.name}
                          width={60}
                          height={60}
                        />
                      </div>
                      <span className={styles.subject__name}>{i.name}</span>
                    </div>
                  </a>
                </Link>
              ),
          )}
        </div>
      </div>
      <button className={styles.show_more} onClick={showMoreSubjectsHandler}>
        {!showMore ? 'Показать все предметы' : 'Показать меньше предметов'}
      </button>
    </div>
  );
};

export default SubjectsList;
